"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var styles_2 = require("../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        root: {
            backgroundColor: (0, styles_2.getTitleColor)(palette)
        },
        titleWithCloseIcon: {
            paddingRight: spacing(6.25)
        }
    });
});
exports.default = useStyles;
